/// <amd-module name="Wit/Common/CreateMenuProvider" />
import * as CommonResources from "Wit/Common/Resources";

import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { onClickFPS } from "VSS/Platform/FPS";
import { routeUrl } from "VSS/Platform/Location";

import { IMenuItem } from "VSSUI/Menu";

import { IMenuService } from "VSS/Features/PlatformUI/ContributedMenu";

import { ITfsPageService } from "Tfs/Platform/Page";

class WitCreateMenuService extends VssService implements IMenuService {
    private menuItems: IMenuItem[] = [];

    public _serviceStart(pageContext: IVssPageContext) {
        super._serviceStart(pageContext);

        const tfsPageService = this.pageContext.getService<ITfsPageService>("ITfsPageService");
        const tfsPageData = tfsPageService.getData();

        if (tfsPageData && tfsPageData.project) {
            this.menuItems.push({
                groupKey: "app-actions",
                href: routeUrl(this.pageContext, "ms.vss-work-web.query-route", {
                    project: tfsPageData.project.name,
                    view: "query-edit",
                    action: "new",
                    newQuery: "true"
                }),
                iconProps: {
                    iconName: "QueryList"
                },
                id: "new-query",
                onActivate: (menuItem, event) => onClickFPS(this.pageContext, menuItem.href!, true, event, { telemetrySource: "NavCreateMenu" }),
                rank: 100,
                text: CommonResources.NewQuery
            });
        }
    }

    public getMenuItems(menuId: string): IMenuItem[] | null {
        if (menuId === "ms.vss-tfs-web.vertical-header-create-menu") {
            return this.menuItems;
        }

        return null;
    }
}

Services.add("work-create-menu-provider", { serviceFactory: WitCreateMenuService });
